import styles from './ControlIcon.module.scss'
import { Icon } from '@percent/lemonade'

export type ControlIconProps = {
  direction: 'previous' | 'next'
  variant?: 'light' | 'dark'
}

export const ControlIcon = ({ direction, variant = 'dark' }: ControlIconProps) => (
  <div className={variant === 'light' ? styles.controlIconLight : styles.controlIconDark}>
    <Icon
      size={4}
      color={variant === 'light' ? 'white' : 'black'}
      name={direction === 'next' ? 'arrow-right' : 'arrow-left'}
    />
  </div>
)
